import { createAppSlice } from "@/store/utils";

import { SetQueueTolerancePayload, ToleranceState } from "./tolerance.types";

const EMPTY_TOLERANCE_QUEUE_IDS: number[] = [];

const initialState: ToleranceState = {
  byCompany: {}
};

export const toleranceSlice = createAppSlice({
  name: "tolerance",
  initialState,
  reducers: (create) => ({
    setQueueTolerance: create.reducer<SetQueueTolerancePayload>((state, { payload }) => {
      const { companyId, queueId, isInTolerance } = payload;

      const companyQueueIds = state.byCompany[companyId] ?? [];
      const exists = companyQueueIds.includes(queueId);

      if (isInTolerance && !exists) {
        state.byCompany[companyId] = [...companyQueueIds, queueId];
        return;
      }

      if (!isInTolerance && exists) {
        state.byCompany[companyId] = companyQueueIds.filter((id) => id !== queueId);
      }
    }),
    clearCompanyTolerance: create.reducer<{ companyId: number }>((state, { payload }) => {
      delete state.byCompany[payload.companyId];
    }),
    clearAllTolerance: create.reducer((state) => {
      state.byCompany = {};
    })
  }),
  selectors: {
    selectToleranceByCompany: (state, companyId: number) => state.byCompany[companyId] ?? EMPTY_TOLERANCE_QUEUE_IDS
  }
});

export const toleranceSliceActions = toleranceSlice.actions;
export const toleranceSliceSelectors = toleranceSlice.selectors;
